<template>
  <div class="bl-wrapper box_v">
    <div class="bl-title box">
      <div>社区活动</div>
    </div>
    <!--轮播图-->
    <div  style="height:510px;width: 1800px;margin:0 auto;position: relative">
      <swiper v-if="scrollImg.length >2" :options="swiperOption" ref="mySwiper" style="padding:10px 0;height:490px ">
        <swiper-slide v-for="(item,index) in scrollImg" :key="index">
          <div class="swiper-img-wrapper">
            <img :src="item.path" class="swiper-img">
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!--活动详情卡片-->
    <sqhd-crad :activityInfo="active" :bmarr="bmarr"></sqhd-crad>
  </div>
</template>

<script>
  var that
  import cascadeLoop from './components/cascadeLoop'
  import sqhdCrad from './components/sqhdCrad'
  export default {
    components: {
      sqhdCrad,
      cascadeLoop
    },
    data () {
      const that = this;
      return {
        swiperOption: {
          observer: true,
          observerParents: true,
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          initialSlide: 0,
          loop:true,
          autoplay:{
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          speed:1000,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 150,
            modifier: 1,
            slideShadows: false
          },
          pagination: {
            el: ".swiper-pagination",
            type : 'custom',
            // 自定义分页样式
            renderCustom: function (swiper, current, total) {
              const activeColor = '#6c6e6d'
              const normalColor = '#c6c6c6'
              let color = ''
              let paginationStyle = ''
              let html = ''
              for (let i = 1; i <= total; i++) {
                if (i === current) {
                  color = activeColor
                } else {
                  color = normalColor
                }
                paginationStyle = `background:${color};opacity:1;margin-right:2px;width:35px;height:6px;border-radius:0`
                html += `<span class="swiper-pagination-bullet" style=${paginationStyle}></span>`
              }
              return html
            },
            progressbarOpposite: true, //使进度条分页器与Swiper的direction参数相反

            // bulletElement: "li", //设定分页器指示器（小点）的HTML标签。

            dynamicBullets: true, //动态分页器，当你的slide很多时，开启后，分页器小点的数量会部分隐藏。

            // dynamicMainBullets: 2, //动态分页器的主指示点的数量

            hideOnClick: true, //默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。

            clickable: true //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。

          },
        },
        img:[],//获取的图片集合
        activeId:'',//活动ID
        active:{},//活动详情
        bmarr:[],//活动报名人
        isloading:false,//图片是否请求完
        // scrollImg:[]
      }
    },
    computed: {
      //请求完照片后 处理img  保证最少三张
      scrollImg () {
        if (this.isloading) {
          if (this.img.length == 1) {
            this.img.push(this.img[0])
            this.img.push(this.img[0])
          }else if (this.img.length ==2) {
            this.img.push(this.img[0])
          }
          console.log(this.img)
          return this.img
        }else {
          return []
        }
      }
    },
    methods: {
      //获取最新一条社区活动，优先级 正在进行>未开始>已结束
      getActive(){
        var url = this.urlobj.getPartyActive;
        this.$get(url, {
          zoneId: '-1'
        }).then(res => {
          that.$store.commit("updateSpinShow", false)
          var req = res.rows[0].detail;
          that.active = {
            cover: req.coverPicUrl,
            title: req.title,
            sponsorName: req.zoneName,//主办方
            starttime: req.beginTime,
            endtime: req.endTime,
            address: req.address,
            qrcode: req.qrcodeUrl,
          };
          var imgArr = [];
          imgArr.push({path:that.active.cover})
          res.rows[0].activityPicList.slice(0,10).forEach(item => {
            imgArr.push({
              path: item
            });
          });
          that.img= imgArr;
          that.isloading = true
          that.bmarr = res.rows[0].applyUserList
            .map(item => {
              return {
                headPicUrl: item.headPicUrl,
                userName: item.userName || "游客",
                time:
                  typeof item.recordTime == "string"
                    ? item.recordTime
                    : that.$util.FormatDate(
                    Number(item.recordTime),
                    "MM-dd  HH:mm"
                    )
              };
            });
        })
      },
    },
    mounted () {
      that=this
      that.$store.commit("updateSpinShow", true);
      that.getActive()
    }
  }
</script>
<style scoped>
  .bl-wrapper{
    width: 100%;
    height: 100%;
    background-image: url("../../assets/staticsPic/2.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .bl-title{
    height:11.76%;
    font-size: 40px;
    justify-content: center;
    align-items: center;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 700px;
    height: 440px;
  }
  .swiper-img-wrapper{
    height:100%;
    background: #000;
    border: 1px solid #9f9e9a;
    box-shadow: 0px 2px 10px 1px #9f9e9a;
  }
  .swiper-img{
    height: 100%;
    width: 100%;
    opacity: 0.5
  }
  .swiper-slide-active .swiper-img{
    opacity: 1 !important;
  }
</style>
